import { Module } from "vuex";
import { actions } from "./actions";
import { getters } from "./getters";
import { mutations } from "./mutations";
import { AuthState } from "./types";
import { RootState } from "../../types";

export const state: AuthState = {
  token: window.localStorage.getItem("dpaID-token") || "",
  status: ""
};

const namespaced: boolean = true;

export const auth: Module<AuthState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
};
